import React, { Fragment } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import LabeledReadOnly from "../../components/LabeledReadOnly";
import ReadOnlyField from "../../components/ReadOnlyField";
import { DateTime } from "luxon";
import { notBlank } from "../../util/ext";

const ContentMetadataParseErrorDialog = ({
  contentMetadataParseError,
  open,
  onCancel,
}) => {
  return (
    <Dialog fullWidth maxWidth="md" open={open}>
      <DialogTitle id="form-dialog-title">
        Content Metadata Parse Error
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <LabeledReadOnly label="Event Timestamp">
              <ReadOnlyField>
                {DateTime.fromISO(contentMetadataParseError.eventTimestamp)
                  .toUTC()
                  .toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Event Type">
              <ReadOnlyField>
                {contentMetadataParseError.eventType}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Job Id">
              <ReadOnlyField>{contentMetadataParseError.jobId}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Execution Id">
              <ReadOnlyField>
                {contentMetadataParseError.executionId}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Media Id">
              <ReadOnlyField>{contentMetadataParseError.mediaId}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="State Machine">
              <ReadOnlyField>
                {contentMetadataParseError.stateMachine}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Task Name">
              <ReadOnlyField>
                {contentMetadataParseError.taskName}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={6}>
            <LabeledReadOnly label="Number of Retries">
              <ReadOnlyField>
                {contentMetadataParseError.taskRetry}
              </ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          <Grid item xs={12}>
            <LabeledReadOnly label="Message">
              <ReadOnlyField>{contentMetadataParseError.message}</ReadOnlyField>
            </LabeledReadOnly>
          </Grid>

          {notBlank(contentMetadataParseError.processingStatus) && (
            <Fragment>
              <Grid item xs={6}>
                <LabeledReadOnly label="Processing Status">
                  <ReadOnlyField>
                    {contentMetadataParseError.processingStatus}
                  </ReadOnlyField>
                </LabeledReadOnly>
              </Grid>

              <Grid item xs={12}>
                <LabeledReadOnly label="Processing Input Source">
                  <ReadOnlyField>
                    {contentMetadataParseError.processingInputSource}
                  </ReadOnlyField>
                </LabeledReadOnly>
              </Grid>

              <Grid item xs={12}>
                <LabeledReadOnly label="Processing Message">
                  <ReadOnlyField>
                    {contentMetadataParseError.processingMessage}
                  </ReadOnlyField>
                </LabeledReadOnly>
              </Grid>
            </Fragment>
          )}

          {notBlank(contentMetadataParseError.etlStatus) && (
            <Fragment>
              <Grid item xs={6}>
                <LabeledReadOnly label="ETL Status">
                  <ReadOnlyField>
                    {contentMetadataParseError.etlStatus}
                  </ReadOnlyField>
                </LabeledReadOnly>
              </Grid>

              <Grid item xs={6}>
                <LabeledReadOnly label="ETL Source">
                  <ReadOnlyField>
                    {contentMetadataParseError.etlSource}
                  </ReadOnlyField>
                </LabeledReadOnly>
              </Grid>

              <Grid item xs={12}>
                <LabeledReadOnly label="ETL Message">
                  <ReadOnlyField>
                    {contentMetadataParseError.etlMessage}
                  </ReadOnlyField>
                </LabeledReadOnly>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContentMetadataParseErrorDialog;
